module.exports = __webpack_public_path__ + "img/示意-其他下载.7b260c8e.png";